module.exports = __webpack_public_path__ + "img/smile.1f6655af.png";